{
  "rovo-button-onboarding-spotlight.copy-version-a.bodyText": [
    {
      "type": 0,
      "value": "Connect the dots, simplify writing, and move projects forward."
    }
  ],
  "rovo-button-onboarding-spotlight.copy-version-a.headlineText": [
    {
      "type": 0,
      "value": "Your AI teammate is here"
    }
  ],
  "rovo-button-onboarding-spotlight.copy-version-b.bodyText": [
    {
      "type": 0,
      "value": "Rovo helps your team turn rough ideas into clear, polished pages."
    }
  ],
  "rovo-button-onboarding-spotlight.copy-version-b.headlineText": [
    {
      "type": 0,
      "value": "Create with AI"
    }
  ],
  "rovo-button-onboarding-spotlight.copy-version-c.bodyText": [
    {
      "type": 0,
      "value": "Your new AI teammate’s here to draft, refine, and summarize content."
    }
  ],
  "rovo-button-onboarding-spotlight.copy-version-c.headlineText": [
    {
      "type": 0,
      "value": "Work smarter with Rovo"
    }
  ],
  "rovo-button-onboarding-spotlight.getStartedButtonLabel": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "rovo-expansion.rovo-3p-connector-admin-activation.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.email.body.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.email.body.hello.subtext": [
    {
      "type": 0,
      "value": "Love using Rovo? Take it to the next level with the Rovo browser extension."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.branded-header.description": [
    {
      "type": 0,
      "value": "Atlassian Rovo logo"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.download-extension": [
    {
      "type": 0,
      "value": "Download the extension"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.extension-screenshot.description": [
    {
      "type": 0,
      "value": "Demo of the extension in action"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.make-rovo-your-own": [
    {
      "type": 0,
      "value": "Here’s what you get"
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.rovo-extension-features.description": [
    {
      "type": 0,
      "value": "Rovo extension features: Chat with your company’s knowledge base, right from any browser tab. Ask questions about what’s open. Get context that connects back to your projects. Pick up where you left off. Rovo’s new tab page keeps your recent work ready after that last unexpected interruption. Create what you need, fast. Instantly create work items across Jira, Confluence, and Loom. Make teamwork easy."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.body.try-it-today": [
    {
      "type": 0,
      "value": "Try it today."
    }
  ],
  "rovo-expansion.rovo-extension-download-end-users.message-template.email.subject": [
    {
      "type": 0,
      "value": "🚀 Try out the Rovo browser extension – Available now"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-no-usage.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-no-usage.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-no-usage.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.email.body.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.email.body.hello.subtext": [
    {
      "type": 0,
      "value": "Companies are using "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AI 400% as often"
        }
      ],
      "type": 8,
      "value": "span"
    },
    {
      "type": 0,
      "value": " with the Rovo browser extension. Scale your org’s AI adoption fast."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.branded-header.description": [
    {
      "type": 0,
      "value": "Atlassian Rovo logo"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.download-extension": [
    {
      "type": 0,
      "value": "Install the extension across your company"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.extension-screenshot.description": [
    {
      "type": 0,
      "value": "Demo of the extension in action"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-aria": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-aria": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-1": [
    {
      "type": 0,
      "value": " • "
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-2": [
    {
      "type": 0,
      "value": " • "
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.full": [
    {
      "type": 0,
      "value": "to opt out of future emails like this"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.short": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-aria": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-title": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.make-rovo-your-own": [
    {
      "type": 0,
      "value": "Make Rovo your own"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.ready-to-roll-out": [
    {
      "type": 0,
      "value": "Ready to roll out?"
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.rovo-features.description": [
    {
      "type": 0,
      "value": "Customize the experience: add your company’s logo, colors, and background to the new tab page. Push your announcements: Company-wide updates and news to every user’s new tab. Users stay in control of their browsing experience by customizing or opting out in their extension settings."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.vitafleet-spotlight.description": [
    {
      "type": 0,
      "value": "Rovo extension with company branding and annoucements."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.why-rovo.description": [
    {
      "type": 0,
      "value": "Rovo is Atlassian’s AI. It is designed for teamwork, connecting knowledge, people, and action to move work forward. Today Rovo includes Enterprise Search, Chat, Studio, Agents, and Skills and can be connected to 50+ 3rd party tools."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.your-team-will-thank-you": [
    {
      "type": 0,
      "value": "Your team will thank you."
    }
  ],
  "rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.subject": [
    {
      "type": 0,
      "value": "🚀 Get the Rovo extension ready for your whole team"
    }
  ],
  "rovo-extension-install-cta-left-nav.chrome-icon-alt": [
    {
      "type": 0,
      "value": "Google Chrome Icon"
    }
  ],
  "rovo-extension-install-cta-left-nav.description": [
    {
      "type": 0,
      "value": "Rovo Chat knows your context. Available from any tab."
    }
  ],
  "rovo-extension-install-cta-left-nav.description.copy-version-b": [
    {
      "type": 0,
      "value": "Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab."
    }
  ],
  "rovo-extension-install-cta-left-nav.description.copy-version-c": [
    {
      "type": 0,
      "value": "30K+ workers use it to chat with AI that understands their company."
    }
  ],
  "rovo-extension-install-cta-left-nav.description.copy-version-d": [
    {
      "type": 0,
      "value": "Chat with AI that understands your projects and teams. No switching tabs needed."
    }
  ],
  "rovo-extension-install-cta-left-nav.dismiss-label": [
    {
      "type": 0,
      "value": "Dismiss message"
    }
  ],
  "rovo-extension-install-cta-left-nav.heading": [
    {
      "type": 0,
      "value": "Get help with what you're working on"
    }
  ],
  "rovo-extension-install-cta-left-nav.heading.copy-version-b": [
    {
      "type": 0,
      "value": "Get answers for work, anywhere"
    }
  ],
  "rovo-extension-install-cta-left-nav.heading.copy-version-c": [
    {
      "type": 0,
      "value": "Unlock Rovo in every tab"
    }
  ],
  "rovo-extension-install-cta-left-nav.heading.copy-version-d": [
    {
      "type": 0,
      "value": "Bring Rovo to every tab"
    }
  ],
  "rovo-extension-install-cta-left-nav.link": [
    {
      "type": 0,
      "value": "Get the browser extension"
    }
  ],
  "rovo-extension-install-cta-left-nav.rovo-icon-alt": [
    {
      "type": 0,
      "value": "Rovo Icon"
    }
  ]
}